module.exports = __webpack_public_path__ + "img/logo.2ac6886a.png";